import { Controller } from 'stimulus'

/**
 * 
 */
export default class extends Controller {
  static get targets() {
    return ['submit', 'check']
  }

  agree(_e) {
    this.submitTarget.disabled = !this.checkTarget.checked
  }

  connect() {
    this.submitTarget.disabled = !this.checkTarget.checked
  }
}
